module.exports = __webpack_public_path__ + "img/checklist.63e390ae.svg";